import { useState } from 'react';
import { faCopy } from '@fortawesome/free-regular-svg-icons';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-hot-toast';
import { ClipboardUtils } from '@framework/ClipboardUtils';
import { DarkTooltip } from '@framework/ui/atoms/Tooltip';

// コピー完了アイコンを表示する時間(ms)
const COPIED_INDICATOR_DURATION = 2000;

export function CopyMessageButton({ text }: { text: string }) {
  const { t } = useTranslation();
  const [copied, setCopied] = useState(false);

  // 空のメッセージにはコピーボタンを表示しない
  if (text.trim().length === 0) {
    return null;
  }

  const handleCopy = async () => {
    try {
      await ClipboardUtils.copy(text);
      setCopied(true);
      window.setTimeout(() => setCopied(false), COPIED_INDICATOR_DURATION);
    } catch (e) {
      console.error(e);
      toast.error(t('common.message.copyFailed'));
    }
  };

  const label = copied ? t('common.message.copySuccess') : t('viewModel.aiChat.copy');

  return (
    <DarkTooltip tooltip={label} placement="top" className="inline-block">
      <button type="button" onClick={handleCopy} className="text-gray-600 hover:text-gray-700" aria-label={label}>
        <FontAwesomeIcon icon={copied ? faCheck : faCopy} className="text-[12px]" />
      </button>
    </DarkTooltip>
  );
}

// メッセージのテキストパートを結合してコピー対象の文字列を作る
export function extractMessageText(parts: { type: string; text?: string }[]): string {
  return parts
    .filter((part) => part.type === 'text' && typeof part.text === 'string')
    .map((part) => part.text)
    .join('\n\n');
}
